// https://xstate.js.org/viz/?gist=3b2dafdc75c875c41dc0b81cf6424046
import { Machine, assign, interpret } from 'xstate';
import { is_debug } from '../../devtools';
import { build_request_params, request } from './request';

// local variables --------------------------------------------------------- //

const debug = is_debug();

// request abort helpers --------------------------------------------------- //

const make_signal = context => {
  const controller = new AbortController();
  context.signal = controller.signal;
};

const abort_request = context => {
  return context.signal.abort;
};

const build_params = context => build_request_params(context);

const update_retries = assign({ retries: context => context.retries + 1 });

const update_result = assign({ result: (context, event) => event.data });

const update_error = assign({ error: (context, event) => event.data });

const can_retry = context => context.retries < context.max_retries;

export const default_context = {
  endpoint: null,
  headers: {},
  method: 'GET',
  data: null,
  data_type: 'json',
  timeout: 10000,
  max_retries: 0,
  retries: 0,
  retry_throttle: [0, 1000, 3000, 10000, 30000],
  signal: null,
  api_request: true,
  versioned: true,
  authenticated: true,
  handle_errors: true,
  result: null,
  error: null,
};

export const request_machine = Machine(
  {
    id: 'request',
    initial: 'idle',
    context: default_context,
    states: {
      idle: {
        on: {
          fetch: 'build',
        },
      },
      build: {
        on: {
          '': {
            target: 'loading',
            actions: ['make_signal', 'build_params'],
          },
          cancel: 'cancelled',
        },
      },
      loading: {
        on: {
          cancel: 'cancelled',
          resolve: 'success',
          reject: 'failure',
        },
        invoke: {
          src: context => request(context),
          onDone: {
            target: 'success',
            actions: ['update_result'],
          },
          onError: {
            target: 'failure',
            actions: ['update_error'],
          },
        },
      },
      failure: {
        on: {
          '': [
            {
              target: 'loading',
              actions: 'update_context',
              cond: 'can_retry',
            },
            {
              target: 'failed',
            },
          ],
          cancel: 'cancelled',
        },
      },
      success: {
        type: 'final',
      },
      cancelled: {
        type: 'final',
      },
      failed: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      make_signal,
      build_params,
      update_retries,
      update_result,
      update_error,
      abort_request,
    },
    activities: {},
    guards: {
      can_retry,
    },
    services: {},
  }
);

export const server_request = context => {
  return interpret(request_machine.withContext(context));
};

export const make_request = async options => {
  const context = {
    ...default_context,
    ...options,
  };

  const service = server_request(context)
    // .onTransition((state) => {
    //   if (debug) {
    //     console.log(`state of request for ${context.endpoint}:`, state.value);
    //     console.log(`context of request for ${context.endpoint}`, state.context);
    //   }
    // })
    .start();

  service.send('fetch');

  const result = new Promise((resolve, reject) => {
    service.onDone(() => {
      if (service.state.value === 'success') {
        return resolve(service.state.context.result);
      } else if (service.state.value === 'failed') {
        const error = service.state.context.error;

        if (!context.handle_errors) {
          return reject(error);
        }

        console.log(error);
      }

      service.stop();
    });
  });

  return await result;
};
